import { cssVars } from '@/app/styles';
import { CHART_TO_COMPONENT } from '@/chart/components/all-charts';
import { ChartSizer } from '@/chart/components/all-charts-styles';
import Header from '@/chart/components/header';
import { ModalCloseButton } from '@/widgets/components/modal-close-button';
import PropTypes from 'prop-types';
import React, { Suspense } from 'react';
import styled from 'styled-components';

const RsModal = React.lazy(() => import('@/widgets/components/rs-modal'));

const ModalHeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 25px;
  width: 100%;

  > div {
    width: 350px;
  }
`;

function ModalHeader(props) {
  const { chartType, onHide, propertyData } = props;

  return (
    <ModalHeaderWrapper>
      <Header
        chartName={chartType}
        marginUnderLabel={10}
        propertyData={propertyData}
      />
      <ModalCloseButton setCurrentId={onHide} />
    </ModalHeaderWrapper>
  );
}

export function AsyncRsModal(props) {
  const { chartType, onHide, propertyData } = props;

  const showModal = Boolean(chartType);
  const CurrentChart = CHART_TO_COMPONENT[chartType];

  return (
    <Suspense fallback={<div />}>
      <RsModal
        open={showModal}
        onClose={onHide}
        css={`
          .rs-modal-content {
            padding-left: ${cssVars.rsModalPaddingLR};
            padding-right: ${cssVars.rsModalPaddingLR};
            width: 760px;
          }
        `}
      >
        <ModalHeader
          closeModal={onHide}
          chartType={chartType}
          propertyData={propertyData}
        />
        {showModal && (
          <ChartSizer height={325}>
            <CurrentChart propertyData={propertyData} barThickness={15} />
          </ChartSizer>
        )}
      </RsModal>
    </Suspense>
  );
}

AsyncRsModal.propTypes = {
  chartType: PropTypes.string,
  onHide: PropTypes.func.isRequired,
  propertyData: PropTypes.object,
};
